import { component } from 'flightjs';

function LoginButtonUI() {
    this._loginSubmit = function () {
        const loginButton = this.$node;
        setTimeout(function () {
            loginButton.prop('disabled', true);
        }, 1);
        return true;
    };

    this.after('initialize', function () {
        this.on('click', this._loginSubmit);
    });
}

export default component(LoginButtonUI);
